import React, {useState, useEffect} from 'react';
import TextDisplay from '../../../Forms/TextDisplay/TextDisplay';
import FormColumn from '../../../Forms/FormColumn/FormColumn';
import TranslateTag from '../../../../Utils/Local/TranslateTag';
import {PostList} from '../../../../Data/Post';

const TableEntry = (props) => {

    const [column, setColumn] = useState();
    const [entryData, setEntryData] = useState({ value: 0, enabled: 0, parentid: 0});

    useEffect(() => {

        let newEntryData = {...props.data};
        if ( Array.isArray(props.data)) {
            newEntryData = {
                Value: newEntryData[0].value,
                Enabled: newEntryData[1].value,
                ParentId: newEntryData[2].value,
                OptionName: newEntryData[3].value
            }
        }

        if (newEntryData.Enabled !== undefined) {
            const fields = [
                {
                    Id: "Value",
                    Label: TranslateTag("@GenVal@", props.language),
                    Type: "singleline",
                    Placeholder: TranslateTag("@PatEntH@", props.language),
                    value: newEntryData.Value
                },
                {
                    Id: "Enabled",
                    Label: TranslateTag("@GenEna@", props.language),
                    Type: "toggle",
                    value: newEntryData.Enabled
                },
            ];
    
            updateFieldChanges(newEntryData);
            setEntryData(newEntryData);
            
            if (newEntryData.OptionName !== undefined && newEntryData.OptionName !== null) {
                const param = [{ name: newEntryData.OptionName, includeFixed: true }];
                PostList(param, listRetrieved, errorHandler,{fields: fields, data: newEntryData});
            } else {
                setColumnValue(fields);
            }
        }
    }, []);

    // const data = props.data;

    const updateFieldChanges = (data) => {

        const changes = [{ key: "Value", value: { Key: "Value", value: data.Value }},
            { key: "Enabled", value: { Key: "Enabled", value: data.Enabled }},
            { key: "ParentId", value: { Key: "ParentId", value: data.ParentId }},
            { key: "OptionName", value: { Key: "OptionName", value: data.OptionName }}
        ];
        setEntryData(data);
        props.changeHandler("multiplechanges", changes, { rootCopy: true });
    }

    const changeHandler = (id, value) => {

        const fields = column.FormGroups[0].Fields;
        if (id === "Value") { fields[0].value = value; }
        if (id === "Enabled") { fields[1].value = value; }
        if (id === "ParentId") { fields[2].value = value; }

        const changes = entryData;
        changes[id] = value;
        updateFieldChanges(changes);
    }

    const listRetrieved = (data, extraInfo) => {
        const newField = {
            Id: "ParentId",
            Label: TranslateTag("@GenPar@", props.language),
            Type: "combobox",
            Options: data[0].options,
            MultiSelect: false,
            Placeholder: TranslateTag("@GenSelG@", props.language),
            value: extraInfo.data.ParentId
        }
        extraInfo.fields.push(newField);
        setColumnValue(extraInfo.fields);
    }

    const errorHandler = (error) => {
        var x = 1;
    }

    const setColumnValue = (fields) => {
        const metadata = { 
            FieldWidth: "wide",
            ItemWidth: "wide", 
            Key: "col1", 
            FormGroups: [{
                Key: "fg1",
                Column: 0,
                Fields: fields
            }]
        }

        setColumn(metadata);
    }

    let display = null;
    if (column !== undefined) {
        display = <FormColumn key={column.Key} config={column} changeHandler={changeHandler}></FormColumn>
    }

    const contentCss = props.fullScreen ? "app-crafted-fullscreencontent" : "app-crafted-content";

    return (
        <div className={contentCss}>
            <div className='app-crafted-title'>{props.config.PageTitle}</div>
            <div className='app-crafted-headertext'>
                <TextDisplay text={props.config.Text}></TextDisplay>
            </div>
            <div>
                {display}
            </div>
        </div>
    );
};
  
export default TableEntry;